import { FunctionComponent, PropsWithChildren } from 'react';
import {
  PageBodyContentContainer,
  PageMainBodyContentContainer,
} from '../../../app-kit/components/PageContentContainer/PageContentContainer';
import { useSchoolPageBySlugTabContentQuery } from '../../graphql/useSchoolPageBySlugTabContentQuery';
import { TabTitle } from './subcomponents/TabTitle/TabTitle';
import { SchoolPaginatedPropertiesBrickWithData } from './subcomponents/SchoolPaginatedPropertiesBrickWithData/SchoolPaginatedPropertiesBrickWithData';

export const SchoolPageTabContentPropertiesForSaleOrRent: FunctionComponent<
  PropsWithChildren
> = () => {
  const { data } = useSchoolPageBySlugTabContentQuery();
  const tabContent = data?.schoolPageBySlug?.tabContent;
  if (!tabContent) return null;

  const { title } = tabContent;

  return (
    <PageBodyContentContainer>
      <PageMainBodyContentContainer>
        {title && <TabTitle>{title}</TabTitle>}
        <SchoolPaginatedPropertiesBrickWithData />
      </PageMainBodyContentContainer>
    </PageBodyContentContainer>
  );
};
